import * as React from 'react';
import {withAuthorization} from "../../firebase/withAuthorization";
import remergeCondition from "../../firebase/conditions";
import {AppState} from "../../store";
import {Dispatch} from "redux";
import {
    ISetActiveAdsIdActionPayload,
    setActiveAdsIdAction,
} from "../../store/organizations/actions";
import {connect} from "react-redux";
import {Button, Icon, Tabs} from "antd";
import {AdLabel, Ads, CampaignWithAds, Campaign,} from "../../store/organizations/types";
import BannerEditor from "../../components/BannerEditor/BannerEditor";
import {RouteComponentProps, withRouter} from "react-router";
import {
    areAdsFetched,
    selectActiveCampaigns, selectAdLabels,
    selectVisibleAdsByActiveCampaignIds
} from "../../store/organizations/selectors";
import {IdObjectsWithId} from "../../utils";
import {IBannerTemplate} from "../../store/banner/template/types";
import {modifyingActiveBannerTemplateAction} from "../../store/banner/template/actions";
import {selectActiveBannerTemplate} from "../../store/banner/template/selectors";
import {IFeedState} from "../../store/feed/types";
import {selectFeedState} from "../../store/feed/selectors";


const {TabPane} = Tabs;

export interface IOwnProps extends RouteComponentProps<IMatchParams> {
}

interface IMatchParams {
    organizationId: string;
    campaignId: string;
}

interface IStoreProps {
    activeBannerTemplate: IBannerTemplate,
    activeCampaigns: Campaign[];
    feed: IFeedState;
    campaignsWithAds: IdObjectsWithId<CampaignWithAds>;
    adLabels: IdObjectsWithId<AdLabel>;
    areAdsFetched: boolean;
}

interface IDispatchProps {
    setActiveAdsId: (params: ISetActiveAdsIdActionPayload) => void;
    modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => void;
}

export type IAdsPreviewerProps = IOwnProps & IStoreProps & IDispatchProps;

class AdsPreviewer extends React.Component<IAdsPreviewerProps> {
    constructor(props: IAdsPreviewerProps) {
        super(props);
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.history.location.search);
        const adId = query.get("ad_id");
        this.switchAd(adId as string, true)
    }

    switchAd = (activeKey: string = "", switchCode: boolean = false): void => {
        // Set the activeBannerTemplate based on the adId.
        // If it's empty, set to the first one in the list since the tab loads the first by default
        let code = "";
        let template = "";
        if (this.props.activeCampaigns && this.props.activeCampaigns.length > 0) {
            const activeCampaign = this.props.activeCampaigns[0];
            const ads = this.props.campaignsWithAds.byId[activeCampaign.id].ads;
            if (activeCampaign && ads && ads.length > 0) {
                code = activeCampaign.code;
                if (activeKey) {
                    const ad = ads.find((ele, idx, arr) => {
                        // The id in ele is actually number returning from api.
                        return ele.id == activeKey
                    });
                    if (ad) {
                        template = ad.template_value
                    }
                } else {
                    template = ads[0].template_value
                }
            }
        }
        if (switchCode) {
            this.props.modifyingActiveBannerTemplate({customCode: code, template: template});
        } else {
            this.props.modifyingActiveBannerTemplate({template: template});
        }
    };

    onTemplateChange = (value: string): void => {
        this.props.modifyingActiveBannerTemplate({template: value});
    };

    onCustomCodeChange = (value: string): void => {
        this.props.modifyingActiveBannerTemplate({customCode: value});
    };

    onNameChange = (e: any): void => {
        this.props.modifyingActiveBannerTemplate({name: e.target.value});
    };

    onAdsTabChange = (activeKey: string) => {
        this.props.setActiveAdsId({adsId: activeKey});
        this.switchAd(activeKey);
        const query = new URLSearchParams(this.props.history.location.search);
        query.set("ad_id", activeKey);
        this.props.history.replace({...this.props.history.location, search: query.toString()})
    };

    render() {
        const query = new URLSearchParams(this.props.history.location.search);
        const adId = query.get("ad_id");
        let activeCampaign = this.props.activeCampaigns[0]
        let organizationId = ""
        let ads: Ads[] = []
        if (activeCampaign) {
            organizationId = activeCampaign.organization_id;
            ads = this.props.campaignsWithAds.byId[activeCampaign.id].ads
        }

        return (
            <div>
                {
                    this.props.areAdsFetched &&
                    <div>
                        <Tabs
                            defaultActiveKey={adId ? adId : ""}
                            animated={false}
                            size="small"
                            onChange={this.onAdsTabChange}
                        >
                            {
                                ads.map((ad: Ads) => {
                                    let tabName = ` `;
                                    if (ad.status === "active") {
                                        tabName += "✅"
                                    } else {
                                        tabName += "⭕"
                                    }
                                    tabName += `[${ad.id}] `;
                                    if (this.props.adLabels.byId[ad.label_id]) {
                                        tabName += this.props.adLabels.byId[ad.label_id].name
                                    }

                                    const adUrl = `https://my.remerge.io/a/organization/${organizationId}/ads/${ad.id}`;

                                    return (
                                        <TabPane
                                            tab={
                                                <span>{tabName}
                                                    <Button
                                                        type="link"
                                                        href={adUrl}
                                                        target="_blank"
                                                    >
                                                        <Icon type="link"/>
                                                    </Button>
                                                </span>
                                            }
                                            key={ad.id}
                                        >
                                            <BannerEditor
                                                template={this.props.activeBannerTemplate.template}
                                                originalTemplate={this.props.activeBannerTemplate.template}
                                                customCode={this.props.activeBannerTemplate.customCode}
                                                feed={this.props.feed}
                                                onTemplateChange={this.onTemplateChange}
                                                onCustomCodeChange={this.onCustomCodeChange}
                                            />
                                        </TabPane>
                                    )
                                })
                            }
                        </Tabs>
                    </div>
                }
            </div>
        )
    };
}

const authCondition = (authUser: any) => remergeCondition(authUser);


const mapStateToProps = (state: AppState) => ({
    feed: selectFeedState(state),
    activeBannerTemplate: selectActiveBannerTemplate(state),
    activeCampaigns: selectActiveCampaigns(state),
    campaignsWithAds: selectVisibleAdsByActiveCampaignIds(state),
    adLabels: selectAdLabels(state),
    areAdsFetched: areAdsFetched(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        setActiveAdsId: (params: ISetActiveAdsIdActionPayload) => dispatch(setActiveAdsIdAction(params)),
        modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => dispatch(modifyingActiveBannerTemplateAction({bannerTemplate: value})),
    };
};


const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdsPreviewer);

export default withAuthorization(authCondition)(withRouter(connected));
